<template>
  <b-container class="enter-location-container my-5 p-5">
    <b-row>
      <b-col>
        <h2>Enter your delivery address</h2>
        <p>This will help us confirm the store's availability.</p>
      </b-col>
    </b-row>
    <b-row class="justify-content-start mt-3">
      <b-col md="5">
        <b-form-group>
          <div
            class="
              form-control
              d-flex
              align-items-center
              justify-content-between
              py-4
              px-1
              border-0
            "
          >
            <span class="px-2">
              <img src="@/assets/images/pin-fill.svg" alt="pin-icon" />
            </span>
            <gmap-autocomplete
              placeholder="Enter address"
              @place_changed="setPlace"
              class="border-0 outline-0 flex-grow-1"
              :options="{
                componentRestrictions: { country: 'ph' },
              }"
              ref="address"
              :value="location"
              :disabled="cart !== null && cart.cart_count > 0"
            >
            </gmap-autocomplete>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      selectedPlace: null,
      storedCoordinates: {},
    };
  },
  computed: {
    ...mapState("estore", ["cart"]),
    ...mapState("customer", ["location"]),
  },
  methods: {
    setPlace(place) {
      this.selectedPlace = place.formatted_address;
      this.storedCoordinates = {
        lat: place.geometry.location.lat(),
        long: place.geometry.location.lng(),
        distance: 8,
      };
      this.$nextTick(() => {
        this.$store.commit("branch/SET_COORDINATES", this.storedCoordinates);
        this.$store.commit("customer/SET_LOCATION", this.selectedPlace);
        this.$root.$emit("inPageMapSetSelectedPlace", this.selectedPlace);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.enter-location-container {
  background: #f7f8f9;
  border-radius: 15px;
  h2 {
    font-size: 26px;
    color: #2f3941;
    @extend .mainFontBold;
  }
  p {
    font-size: 14px;
    color: #68737d;
  }
  .form-control {
    .pac-target-input {
      font-size: 16px;
      color: #2f3941;
    }
  }
}
</style>